module.exports = __webpack_public_path__ + "static/bg-cobr-b66a13635a16d50f17334e8d0acd5044.webp";